import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import { useProductSet } from './context/ProductSetProvider';
import ListToolBarActions from 'components/toolbar/ListToolBarActions';

interface SetToolBarProps {
    setEditSetId: (setId: number) => void;
}

const SetToolBar = ({ setEditSetId }: SetToolBarProps) => {
    const { t } = useTranslation(['Sets', 'common']);
    const { auth } = useAuth();
    const { triggerListReset, triggerListRefresh } = useProductSet();

    return (
        <div className="mb-3" style={{ minWidth: '100px' }}>
            <div className="page-toolbar-actions">
                {hasUserAccess(auth?.user, 'prodEdit') && (
                    <Button className="fs-14 ms-1" size="sm" variant="success" onClick={() => setEditSetId(0)}>
                        <i className="bi bi-plus fs-14 p-0"></i>
                        <span className="ms-1">{t('toolAddSet')}</span>
                    </Button>
                )}

                <ListToolBarActions onReset={triggerListReset} onRefresh={triggerListRefresh} />
            </div>
        </div>
    );
};

export default SetToolBar;
